<template>
  <v-container>
    <div class="d-flex align-center mb-3">
      <h3>ຄຳຂໍລຶບບິນ ລໍຖ້າອະນຸມັດ</h3>
      <v-spacer />
      <v-btn
        text
        small
        :loading="loading"
        @click="load"
      >
        <v-icon left>
          mdi-refresh
        </v-icon>
        ໂຫລດໃໝ່
      </v-btn>
    </div>

    <div
      v-if="!loading && !requests.length"
      class="pa-6 text-center grey--text"
    >
      ບໍ່ມີຄຳຂໍທີ່ລໍຖ້າອະນຸມັດ
    </div>

    <v-card
      v-for="req in requests"
      :key="req.id"
      outlined
      class="pa-3 mb-3"
    >
      <div class="d-flex flex-wrap align-center">
        <div class="font-weight-medium">
          ຄຳຂໍ #{{ req.id }} · {{ req.items.length }} ໃບ · ລວມ {{ money(total(req)) }} ກີບ
        </div>
        <v-spacer />
        <div class="text-caption grey--text">
          ສົ່ງໂດຍ {{ req.submitter && req.submitter.name }} · {{ req.created_at }}
        </div>
      </div>
      <div class="text-body-2 mt-1">
        <span class="grey--text">ເຫດຜົນ:</span> {{ req.reason }}
      </div>
      <v-simple-table
        dense
        class="mt-2"
      >
        <thead>
          <tr>
            <th>ເລກບິນ</th>
            <th>ລູກຄ້າ</th>
            <th>ລາຍການ</th>
            <th>ເດືອນບິນ</th>
            <th class="text-right">
              ຍອດເງິນ
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="bill in req.items"
            :key="bill.id"
          >
            <td>{{ bill.bill_number }}</td>
            <td>
              {{ bill.customer_name }}
              <span class="text-caption grey--text">{{ bill.customer_code }} · {{ bill.customer_phone }}</span>
            </td>
            <td>{{ bill.content }}</td>
            <td>{{ bill.bill_date ? bill.bill_date.slice(0, 7) : '' }}</td>
            <td class="text-right">
              {{ money(bill.total) }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <div class="d-flex mt-3">
        <v-spacer />
        <v-btn
          text
          color="red"
          class="mr-2"
          @click="openReject(req)"
        >
          ປະຕິເສດ
        </v-btn>
        <v-btn
          color="error"
          depressed
          @click="openApprove(req)"
        >
          <v-icon left>
            mdi-delete
          </v-icon>
          ອະນຸມັດ ແລະ ລຶບ {{ req.items.length }} ໃບ
        </v-btn>
      </div>
    </v-card>

    <v-dialog
      v-model="approveDialog"
      max-width="460"
    >
      <v-card v-if="current">
        <v-card-title>ຢືນຢັນການລຶບບິນ</v-card-title>
        <v-card-text>
          ລຶບ {{ current.items.length }} ໃບ (ລວມ {{ money(total(current)) }} ກີບ) ຂອງຄຳຂໍ #{{ current.id }}?
          ບິນທີ່ລຶບແລ້ວ ຈະເຫັນຢູ່ໜ້າປະຫວັດການລຶບບິນ.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="approveDialog = false"
          >
            ຍົກເລີກ
          </v-btn>
          <v-btn
            color="error"
            depressed
            :loading="working"
            @click="approve"
          >
            ອະນຸມັດ ແລະ ລຶບ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="rejectDialog"
      max-width="460"
    >
      <v-card v-if="current">
        <v-card-title>ປະຕິເສດຄຳຂໍ #{{ current.id }}</v-card-title>
        <v-card-text>
          <v-textarea
            v-model="rejectReason"
            outlined
            rows="2"
            auto-grow
            label="ເຫດຜົນທີ່ປະຕິເສດ *"
            :error-messages="rejectError"
            @input="rejectError = ''"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="rejectDialog = false"
          >
            ຍົກເລີກ
          </v-btn>
          <v-btn
            color="red"
            dark
            depressed
            :loading="working"
            @click="reject"
          >
            ປະຕິເສດ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: 'BillDeleteApproval',
  title() {
    return 'Vientiane Waste Co-Dev|Bill Delete Approval';
  },
  data() {
    return {
      requests: [],
      loading: false,
      current: null,
      approveDialog: false,
      rejectDialog: false,
      rejectReason: '',
      rejectError: '',
      working: false,
    };
  },
  created() {
    this.load();
  },
  methods: {
    money(value) {
      return Number(value || 0).toLocaleString();
    },
    total(req) {
      return req.items.reduce((sum, bill) => sum + Number(bill.total || 0), 0);
    },
    load() {
      this.loading = true;
      this.$axios
        .get('bill-delete-request/pending', { params: { per_page: 100 } })
        .then((res) => {
          this.requests = res.data.data.data || [];
        })
        .catch((error) => this.toast('error', this.message(error)))
        .finally(() => {
          this.loading = false;
        });
    },
    openApprove(req) {
      this.current = req;
      this.approveDialog = true;
    },
    openReject(req) {
      this.current = req;
      this.rejectReason = '';
      this.rejectError = '';
      this.rejectDialog = true;
    },
    approve() {
      this.working = true;
      this.$axios
        .post(`bill-delete-request/${this.current.id}/approve`)
        .then(() => {
          this.toast('success', `ລຶບບິນຂອງຄຳຂໍ #${this.current.id} ແລ້ວ`);
          this.approveDialog = false;
          this.load();
        })
        .catch((error) => this.toast('error', this.message(error)))
        .finally(() => {
          this.working = false;
        });
    },
    reject() {
      if (!this.rejectReason || !this.rejectReason.trim()) {
        this.rejectError = 'ກະລຸນາໃສ່ເຫດຜົນ';
        return;
      }
      this.working = true;
      this.$axios
        .post(`bill-delete-request/${this.current.id}/reject`, { reason: this.rejectReason.trim() })
        .then(() => {
          this.toast('success', `ປະຕິເສດຄຳຂໍ #${this.current.id} ແລ້ວ`);
          this.rejectDialog = false;
          this.load();
        })
        .catch((error) => this.toast('error', this.message(error)))
        .finally(() => {
          this.working = false;
        });
    },
    message(error) {
      return (error.response && error.response.data && error.response.data.message) || 'Something went wrong';
    },
    toast(color, msg) {
      this.$store.commit('Toast_State', { value: true, color, msg });
    },
  },
};
</script>
